import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import MPZColorPicker from './ColourPicker.jsx'
import SiteVars from '~/Classes/siteVars'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import { DEFAULT_IMAGE_OVERLAY, channelsToHex8, colorToOverlayValue } from '~/utils/TemplateEditor/landingBackground'
import { hasBackgroundImageForColorPath, overlayPickerColor } from './colorPickerUtils'

export default class ComponentSelect extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showPicker: false,
            pickerX: 0,
            pickerY: 0,
            arrowStyle: {},
            pickerReady: false
        }

        this.change = this.change.bind(this)
        this.clear = this.clear.bind(this)
        this.showPicker = this.showPicker.bind(this)
        this.positionPicker = this.positionPicker.bind(this)
    }

    showPicker() {
        if (this.state.showPicker) {
            this.setState({ showPicker: false, pickerReady: false })
            return
        }
        this.setState({ showPicker: true, pickerReady: false }, () => {
            this.positionPicker()
        })
    }
    change(thisVal) {
        if (typeof thisVal === 'string' && thisVal.trim().toLowerCase() === 'transparent') {
            this.props.updateVal(this.props.path, 'transparent')
            return
        }
        if (typeof thisVal === 'object' && thisVal !== null) {
            if (this.props.allowAlpha && thisVal.rgb) {
                const { r, g, b, a } = thisVal.rgb
                const fromDefaultOverlay = overlayPickerColor(this.props) === DEFAULT_IMAGE_OVERLAY
                const isStillDefaultBlack = Number(r) === 0 && Number(g) === 0 && Number(b) === 0
                let alpha = a == null ? 1 : a
                if (fromDefaultOverlay && !isStillDefaultBlack) {
                    alpha = 1
                }
                this.props.updateVal(this.props.path, channelsToHex8(r, g, b, alpha))
            } else if (this.props.allowAlpha && thisVal.hex) {
                this.props.updateVal(this.props.path, colorToOverlayValue(thisVal.hex))
            } else {
                this.props.updateVal(this.props.path, thisVal.hex)
            }
        } else if (this.props.allowAlpha && typeof thisVal === 'string') {
            this.props.updateVal(this.props.path, colorToOverlayValue(thisVal))
        } else {
            this.props.updateVal(this.props.path, thisVal)
        }
    }

    clear(event) {
        event.preventDefault()
        event.stopPropagation()
        this.props.updateVal(this.props.path, 'transparent')
    }

    positionPicker() {
        const triggerEl = this.refs.theColorHolder
        if (!triggerEl) return

        const trigger = triggerEl.getBoundingClientRect()
        const popupWidth = 306
        const popupHeight = 486
        const gap = 8

        const viewport = {
            width: window.innerWidth,
            height: window.innerHeight
        }

        const spaceRight = viewport.width - trigger.right
        const spaceLeft = trigger.left

        let finalX = trigger.right + gap
        let arrowStyle = {
            borderRight: '10px solid #FFFFFF',
            borderLeft: '0',
            left: '-10px',
            right: 'unset'
        }

        if (spaceRight < popupWidth + 20 && spaceLeft > popupWidth + 20) {
            finalX = trigger.left - popupWidth - gap
            arrowStyle = {
                borderLeft: '10px solid #FFFFFF',
                borderRight: '0',
                left: 'unset',
                right: '-10px'
            }
        }

        let finalY = trigger.top + trigger.height / 2 - popupHeight / 2
        if (finalY < 20) {
            finalY = 20
        }

        if (finalY + popupHeight > viewport.height - 20) {
            finalY = viewport.height - popupHeight - 20
        }

        this.setState({
            pickerX: finalX,
            pickerY: finalY,
            arrowStyle: arrowStyle,
            pickerReady: true
        })
    }

    render() {
        const pickerColor = overlayPickerColor(this.props)
        const hasBackgroundImage = hasBackgroundImageForColorPath(this.props)
        var currentColorStyle = {}
        if (pickerColor === 'transparent') {
            currentColorStyle.backgroundImage =
                'url(' + SiteVars.repoEndPoint + 'siteContent/assets/templates/common/empty-color.svg)'
        } else {
            currentColorStyle.backgroundColor = pickerColor
        }

        var style = {}
        if (this.props.elementData.optionFullWidth || hasBackgroundImage) style = { flex: '100%' }
        let outerClass = 'dndEditorv2-dd_toolHolder'
        if (this.props.elementData.optionHalfWidth && !hasBackgroundImage) {
            outerClass += ' dndEditorv2-dd_toolHolder-half'
        }
        return (
            <div className={outerClass} style={style}>
                <div className='dd_inputTool'>
                    <div className='txtInput_label'>{this.props.title}</div>
                    <div
                        style={hasBackgroundImage ? { display: 'flex', alignItems: 'center', gap: '8px' } : undefined}
                    >
                        <div
                            className='dndEditorv2-inputWrapper'
                            style={hasBackgroundImage ? { flex: '1 1 auto', minWidth: 0 } : undefined}
                        >
                            <div className='dndEditorv2-colorHolder' ref='theColorHolder' onClick={this.showPicker}>
                                <div className='dndEditorv2-colorHolderInner' style={currentColorStyle}></div>
                                <div className='dndEditorv2-colorHolderText' style={{ textTransform: 'capitalize' }}>
                                    {pickerColor ? pickerColor : 'Transparent'}
                                </div>
                            </div>
                        </div>
                        {hasBackgroundImage && (
                            <Button
                                type='button'
                                text='Clear'
                                className='button-sml outline grey'
                                style={{ flexShrink: 0 }}
                                onClick={this.clear}
                            />
                        )}
                    </div>
                    {this.state.showPicker &&
                        ReactDOM.createPortal(
                            <div>
                                <div
                                    onClick={this.showPicker}
                                    style={{
                                        position: 'fixed',
                                        top: '0px',
                                        left: '0px',
                                        right: '0px',
                                        bottom: '0px',
                                        zIndex: 9999998
                                    }}
                                />
                                <div
                                    className='dndEditorv2-dd_colorPickerPop'
                                    ref='colorPopper'
                                    style={{
                                        position: 'fixed',
                                        left: this.state.pickerX,
                                        top: this.state.pickerY,
                                        zIndex: 9999999,
                                        visibility: this.state.pickerReady ? 'visible' : 'hidden'
                                    }}
                                >
                                    <div className='dd_colorPickerPop_arrow' style={this.state.arrowStyle} />
                                    <MPZColorPicker
                                        color={pickerColor}
                                        onChange={this.change}
                                        allowAlpha={!!this.props.allowAlpha}
                                        globalColours={this.props.globalColours}
                                        favoriteColors={this.props.favoriteColors}
                                        saveFaveColor={this.props.saveFaveColor}
                                    />
                                </div>
                            </div>,
                            document.body
                        )}
                </div>
            </div>
        )
    }
}
